import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetDepositBankAccountRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getDepositBankAccount = async (
  instance: AxiosInstance,
  params: DefaultApiGetDepositBankAccountRequest
) => {
  return await userApiDefaultApiFactory(instance).getDepositBankAccount(params)
}

// Do Not Remove this line ===@import api client===
